import "core-js/modules/es.string.replace.js";
import React, { useMemo } from "react";
import Typography from "../Typography";
import Box from "../Box";
import Checkbox from '../Checkbox';
import ActionGroup from "../ActionGroup";
const ListHeaderCoordinator = _ref => {
  let {
    results,
    labelShowingTotalResults = "${total} Results",
    labelResults,
    labelShowingTotalSelectedResults = "${total} Selected",
    selectedIds = [],
    allSelected = false,
    onSelectAllChange,
    selectionContext,
    SelectedActionGroupProps,
    GlobalActionGroupProps,
    selectionType = 'multiple',
    compact = false
  } = _ref;
  const interpolatedLabelShowingTotalResults = labelShowingTotalResults.replace(/\$\{total\}/, String(results.totalCount));
  const interpolatedLabelShowingSelectedResults = labelShowingTotalSelectedResults.replace(/\$\{total\}/, String(selectedIds.length));
  const hasSelected = selectedIds && selectedIds.length > 0;
  const renderCheckBox = useMemo(() => {
    const isIntermediate = !allSelected && hasSelected;
    const isSelectAllChangeFunctionValid = typeof onSelectAllChange === 'function';
    return isSelectAllChangeFunctionValid ? /*#__PURE__*/React.createElement(Checkbox, {
      sx: {
        marginLeft: -1
      },
      checked: hasSelected,
      indeterminate: isIntermediate,
      onClick: event => onSelectAllChange && onSelectAllChange(event, allSelected ? 'unselectAll' : 'selectAll', selectionContext)
    }) : null;
  }, [selectedIds, hasSelected, allSelected, onSelectAllChange]);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      flex: 1,
      display: 'flex',
      alignItems: 'center'
    }
  }, selectionType === 'multiple' && renderCheckBox, hasSelected ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "component-header-coordinator",
    color: "inherit",
    variant: "overline",
    sx: {
      whiteSpace: "nowrap"
    }
  }, interpolatedLabelShowingSelectedResults), SelectedActionGroupProps && /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement(ActionGroup, SelectedActionGroupProps))) : /*#__PURE__*/React.createElement(React.Fragment, null, compact == false && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "component-header-coordinator",
    color: "inherit",
    variant: "overline",
    sx: {
      whiteSpace: "nowrap"
    }
  }, interpolatedLabelShowingTotalResults, " ", labelResults), GlobalActionGroupProps && /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement(ActionGroup, GlobalActionGroupProps))));
};
export default ListHeaderCoordinator;